import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from '@/vuetify';
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import ErrorLoggingService from './ErrorLoggingService';

Vue.config.productionTip = false

Vue.config.errorHandler = (err: Error, vm, info) => {
  console.error(err)
  const msg = err.message
  const stack = err.stack || ''
  const errString = stack.indexOf(msg) >= 0 ? stack : msg + stack //msg is sometimes repeated at the start of stack
  ErrorLoggingService.LogClientError(errString)
}

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
